// React Basic and Bootstrap
import React, { Component } from "react";
import { Row, Col, Alert } from "reactstrap";
import axios from "axios";

//import images
import bg04 from "../../images/hosting/bg4.png";

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Contactvisible: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleSubmit(event) {
    event.preventDefault();
    let url = window.location.href;
    if (url.search("/index") === -1) {
      url = url.replace(".cl", ".cl/mensaje/");
    } else {
      url = url.replace("/index", "/mensaje/");
    }
    url = url.replace("mensaje//", "mensaje/");

    const msj = {
      nombre: event.target.name.value,
      correo: event.target.email.value,
      asunto: "Desde página inicio",
      mensaje: "Sin mensaje",
      telefono: event.target.phone.value
    };

    axios
      .post(
        url,
        { msj },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
      .catch(e => e);
    this.setState({ Contactvisible: true });
  }

  render() {
    return (
      <React.Fragment>
        <section
          className="section"
          style={{ background: `url(${bg04}) center center` }}
        >
          <div className="container">
            <Row className="align-items-center">
              <Col lg={8} md={7}>
                <div className="section-title mr-lg-4">
                  <h4 className="main-title text-light mb-4">
                    ¡No esperes más! Comencemos con tú sitio hoy
                  </h4>
                  <p className="text-light para-desc mb-0">
                    Envíanos tus datos y nos pondremos en contacto a la brevedad
                  </p>
                </div>
              </Col>

              <Col lg={4} md={5} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                <div className="bg-white rounded p-4 shadow">
                  <h5 className="text-capitalize text-center">Contacto</h5>
                  <Alert
                    color="info"
                    isOpen={this.state.Contactvisible}
                    toggle={() => {
                      this.setState({
                        Contactvisible: !this.state.Contactvisible
                      });
                    }}
                  >
                    ¡Mensaje enviado! Te contactaremos a la brevedad.
                  </Alert>
                  <form onSubmit={this.handleSubmit}>
                    <Row className="mt-4">
                      <Col lg={12}>
                        <div className="form-group mb-3">
                          <label>
                            Tu Nombre <span className="text-danger">*</span>
                          </label>
                          <input
                            name="name"
                            id="name"
                            type="text"
                            className="form-control"
                            placeholder="Nombre"
                            required
                          />
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="form-group mb-3">
                          <label>
                            Tu Email <span className="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            id="email"
                            className="form-control"
                            placeholder="Email"
                            name="email"
                            required
                          />
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="form-group">
                          <label>
                            Teléfono
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            name="phone"
                            id="phone"
                            type="number"
                            className="form-control"
                            placeholder="+569 9999 9999"
                            required
                          />
                        </div>
                      </Col>

                      <Col lg={12} className="mb-0">
                        <button className="btn btn-warning btn-block">
                          Comienza ya
                        </button>
                      </Col>
                    </Row>
                  </form>
                </div>
              </Col>
            </Row>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default ContactForm;
